import GameEvents from "../../../vendor_core/core/src/const/GameEvents";
import SpinModel from "../../../vendor_core/core/src/model/SpinModel";
import { IWinData } from "../../../vendor_core/core/src/server/data/ISpinData";
import GameModel from "../../../vendor_core/core/src/model/GameModel";
import BBWinlinesView from "./BBWinlinesView";
import { TimelineMax, TweenMax } from "gsap";
import BBWinSymbolsView from "./BBWinSymbolsVew";
import { DefaultLayers } from "../../../vendor_core/core/src/utils/Layers";
import ViewManager from "../../../vendor_core/core/src/utils/ViewManager";
import CascadeReelGroup from "../../../vendor_core/core/src/views/CascadeReelGroup";
import SoundController from "../../../vendor_core/core/src/utils/SoundController";
import App from "../../../vendor_core/core/src/App";
import BBReelSymbol from "./BBSymbol";
import SymbolSpineAnimation from "../../../vendor_core/core/src/views/SymbolSpineAnimation";
import PromiseHelpers from "../../../vendor_core/core/src/utils/PromiseHelpers";
import BBAnimationHelper from "../utils/BBAnimationsHelper";
import BBAnimationsHelper from "../utils/BBAnimationsHelper";
import BBReelReverseCascadeBehaviour from "./BBReelReverseCascadeBehaviour";
import { BoundUtils } from "../utils/BoundUtils";
import { Container, DisplayObject, Graphics, Rectangle } from "pixi.js";
import Layout from "../../../vendor_core/core/src/utils/Layout";

class BBReelGroup extends CascadeReelGroup {
    public anticipateReels: number[];
    public symAnimationCount: number = 0;
    public winlinesView: BBWinlinesView;
    public winSymbolsView: BBWinSymbolsView;
    public wildSymbolAnim: PIXI.extras.AnimatedSprite;
    public showWinStateDelayedExit: number = 0.8;
    public thunderBoltAnimSpeed = 1;
    public currentBanners: any = [];
    private reelBoundScalar: number = 0.98;
    private symbolBounds: Rectangle = Rectangle.EMPTY;

    private showOriginalSymbolSprite: boolean = false;
    private anticipateSound: Howl;

    constructor() {
        super();
    }
    public spin() {
        // To avoid possible issues
        // TweenMax.killAll()
        TweenMax.killDelayedCallsTo(this.stopReels);
        // Clean props
        this.hasAnticipation = false;
        this.spinDelayedCalls = [];
        this.reelsSpinning = 0;
        this.reelsCascading = 0;
        this.isMinSpinTimeComplete = false;
        this.stopSymbolsAvailable = false;
        this.stoppingStarted = false;
        this.stopDelayedCalls = [];
        SpinModel.stopImmediately = false;

        // debugger

        // Start the spinning
        let delay = 0;
        this.spinStartTime = Date.now();
        this.spinners.forEach((spinner, reelIdx) => {
            delay +=
                this.config.cascadeAnimation.reelDelayTime *
                (this.inCascade ? 0 : 1);

            spinner.animationStartDelay = delay;
            this.reelsSpinning++;
            this.reelsCascading++;
            this.reels[reelIdx].on(
                GameEvents.CASCADE_STOPPED,
                this.onReelCascade,
                this
            );
        });

        this.spinners.forEach((spinner, reelIdx) => {
            spinner.spin();
        });

        ViewManager.getLayer(DefaultLayers.Reels)
            .getCurrentScene()
            .containers.get("reels")
            .enableMask();

        // Set the delay for stopping
        // console.log(this.config.minSpinTime);
        // if (this.config.minSpinTime < 3) {
        //     debugger
        // }

        let reelDelay = this.config.minSpinTime;
        if (GameModel.turboSpin) {
            reelDelay = this.config.quickSpinTime;
        }

        if (this.inCascade) {
            reelDelay = 0.5;
        }

        // this.addDelayedCall(reelDelay, this.allowStop, [], this);
    }

    public highlightWinlineWin(winlineData: IWinData, showWinValue: boolean) {
        // ViewManager.getLayer(DefaultLayers.Reels).getCurrentScene().containers.get("reels").disableMask();
        super.highlightWinlineWin(winlineData, showWinValue);
    }

    public stopSymbolAnimations() {
        this.off(GameEvents.GROUP_ANIM_COMPLETE);

        if (this.showOriginalSymbolSprite) {
            for (let i = 0; i < this.reels.length; i++) {
                const reel = this.reels[i];
                const numSyms = reel.symbols.length;
                for (let symIdx = 0; symIdx < numSyms; symIdx++) {
                    reel.symbols[symIdx].stopAnimation();
                }
            }

            this.winSymbolsView.stopAll();
        }
    }

    public wildAnim(wildPosition: any, numberOfLoops: any, windata: any) {
        // TO DO check for quality of anim  here !!!
        const frames = this.assets.generateFrames(
            "sym_star" + "_",
            3,
            GameModel.gameConfig.animData["sym_star"].numFrames
        );

        let wildSymbol = this.getSymbolAt(wildPosition.x, wildPosition.y);
        const sprite = new PIXI.extras.AnimatedSprite(frames);
        this.wildSymbolAnim = sprite;
        sprite.animationSpeed = GameModel.gameConfig.popAnimSpeed;
        this.popAnimationSprites.push(sprite);
        sprite.anchor.set(0.5, 0.5);
        sprite.loop = false;
        sprite.position.x = wildSymbol.x;
        sprite.position.y = wildSymbol.y;
        sprite.width = wildSymbol.width * 2;

        sprite.height = wildSymbol.height * 2;

        let tl = new TimelineMax({
            paused: false,
            onStart: () => {
                let symbol = this.winSymbolsView.getAnimAtReelCell(
                    wildPosition.x,
                    wildPosition.y
                );
                let parentSym = symbol.parent;
                parentSym.removeChild(symbol);
                parentSym.addChild(symbol);
                symbol.visible = false;
                symbol.parent.addChild(sprite);
            },
        });

        let scaleAdd = 0.2;

        for (let i = 0; i < numberOfLoops; i++) {
            tl.add(
                TweenMax.to(sprite.scale, 0.5, {
                    x: sprite.scale.x + scaleAdd,
                    y: sprite.scale.y + scaleAdd,
                }),
                i == 0 ? 1 : i + 0.8
            );

            tl.add(
                () => {
                    sprite.gotoAndPlay(0);
                },
                i == 0 ? 1 : i + 0.8
            );
            if (i == numberOfLoops - 1) {
                let delay = "+=" + (numberOfLoops * 0.2).toString();
                tl.add(
                    TweenMax.to(sprite.scale, 1, {
                        x: 0.85,
                        y: 0.85,
                        onComplete: () => {
                            let symbol = this.winSymbolsView.getAnimAtReelCell(
                                wildPosition.x,
                                wildPosition.y
                            );
                            symbol.visible = this.showOriginalSymbolSprite;
                            sprite.destroy();
                        },
                    }),
                    delay
                );
                tl.add(this.shrinkMegaSymbols(windata, wildPosition), "-=1");
            }
            scaleAdd += 0.2;
        }
        return tl;
    }

    public removeWildAnim() {
        this.symContainer.removeChild(this.wildSymbolAnim);
    }

    public restoreWildAnim() {}

    protected rotateSymbols() {
        this.reels.forEach((reel) => {
            reel.symbols.forEach((symbol) => {
                TweenMax.to(symbol, 0.5, {
                    rotation: 1,
                    repeat: 1,
                    yoyo: true,
                });
            });
        });
    }

    protected stopIfItPossible = () => {
        this.stoppingStarted = true;
        // debugger
        let delay = 0;
        let symbols = SpinModel.getCurrentFinalSymbols();

        // TODO:  If this is a re-spin - get the correct symbols
        //if (this.isRespin) {
        // symbols = SpinModel.getNextGenSymbols();
        //}

        let previousAnticipation = false;
        // Loop through the reels and stop each
        this.spinners.forEach((spinnerBehavior, reelIdx) => {
            if (this.isRespin && !this.lastRemovedSymbols[reelIdx]) {
                return;
            }

            // let anticipationDelay = previousAnticipation == true;

            // previousAnticipation = false;

            const reel = this.reels[reelIdx];
            reel.once(
                GameEvents.REEL_STOPPED,
                () => this.onReelStopped(reelIdx),
                this
            );

            // Put a delay between reel stops - grows for each reel
            // If we have anticipation - longer delay should be used

            // let anticipationData = SpinModel.getCurrentSpinProperty(
            //     "spinification"
            // );

            // // if (
            // //     anticipationData &&
            // //     anticipationData.spinificationIndex <= reelIdx &&
            // //     anticipationData.spinificationEndIndex >= reelIdx
            // // ) {
            // //     // console.log("Anticipate reel -> " + reelIdx, anticipationData);
            // //     this.hasAnticipation = true;
            // //     previousAnticipation = true;
            // //     spinnerBehavior.activateAnticipation();
            // //     delay += reelIdx * App.config.reelSpinificationDuration;
            // //     this.anticipateSound = SoundController.playSound(
            // //         "anticipation"
            // //     );
            // //     this.anticipateSound.loop();
            // } else if (anticipationDelay) {
            //     delay += reelIdx * App.config.reelSpinificationDuration;
            // } else {
            //     delay += this.config.cascadeAnimation.reelDelayTime;
            //     if (this.anticipateSound != null) {
            //         if (this.anticipateSound.playing())
            //             this.anticipateSound.stop();
            //     }
            // // }

            // spinnerBehavior.animationStartDelay =
            //     this.inCascade && !previousAnticipation && !anticipationDelay
            //         ? delay * 0.7
            //         : delay;

            // console.log(
            //     "[" +
            //     reelIdx +
            //     "] " +
            //     anticipationDelay +
            //     " -> " +
            //     previousAnticipation
            // );

            // if (anticipationDelay) {
            //     spinnerBehavior.animationStartDelay =
            //         spinnerBehavior.animationStartDelay * 2;
            // }

            // console.log(spinnerBehavior.animationStartDelay);

            let hasWild = false;

            const currentGenSymbols = SpinModel.getCurrentGenSymbols()[reelIdx];

            // console.log('Current gen:', currentGenSymbols);
            // console.log(
            //     "Current sstops:",
            //     SpinModel.getStopSymsForReel(reelIdx)
            // );

            for (let ix = 0; ix < currentGenSymbols.length; ix++) {
                if (currentGenSymbols[ix] == "WI") {
                    hasWild = true;
                    break;
                }
            }

            // Then stop the reel
            (spinnerBehavior as unknown as BBReelReverseCascadeBehaviour).stop(
                symbols[reelIdx],
                previousAnticipation,
                hasWild
            );

            // this.reels[reelIdx].symbols.forEach(sym => () => sym.show());
        });
        // OVERLAPPING SYMBOOLS FIX - REARRANGES THE SYMBOLS
        let sortedSymbols = [];
        let wilds = [];
        for (let i = 0; i < 8; i++) {
            for (let j = 0; j < 8; j++) {
                if (this.showOriginalSymbolSprite) {
                    this.reels[i].symbols[j].show();
                }

                if (this.reels[i].symbols[j].id == 0) {
                    wilds.push(this.getSymbolAt(i, j));
                } else {
                    sortedSymbols.push(this.getSymbolAt(i, j));
                }
            }
        }
        wilds.forEach((wild) => {
            sortedSymbols.push(wild);
        });

        this.symContainer.children = sortedSymbols;

        this.dispatcher.emit(GameEvents.REEL_STOP_STARTED);

        // End the cascade flag
        this.inCascade = false;
    };

    protected stopReels() {
        // if (SpinModel.cascadeIndex < 1) {
        //     SoundController.playSound(SoundVars.EFFECT_REEL_STOP);
        // }
        if (this.stoppingStarted) {
            return;
        }

        let stopTime = Date.now();
        let spinEstimate = (stopTime - this.spinStartTime) / 1000;
        // ConsoleUtil.red("start time", this.spinStartTime)
        // ConsoleUtil.red("now time", stopTime);
        // ConsoleUtil.red("result", (stopTime - this.spinStartTime) / 1000);
        // console.log(this.inCascade);

        if (
            spinEstimate >= GameModel.gameConfig.minSpinTime ||
            this.inCascade
        ) {
            this.stopIfItPossible();
        } else {
            let delay = Math.abs(
                GameModel.gameConfig.minSpinTime - spinEstimate
            );
            // ConsoleUtil.green("delay", delay)
            TweenMax.delayedCall(delay, () => {
                // ConsoleUtil.red("final Time: ", (Date.now() - this.spinStartTime) / 1000);
                this.stopIfItPossible();
            });
        }
    }

    public displaySummaryResult(winlinesToShow: IWinData[]) {
        if (GameModel.gameConfig.waysGame) {
            //** WAYS WIN **/
            // this.showWaysSummary(winlinesToShow);
            this.showWaysSummaryNew(winlinesToShow);
        } else {
            //** WIN LINES WIN **/
            this.showSummaryWinLines(winlinesToShow);
        }
    }

    /////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    public showWaysSummaryNew = (windata: IWinData[]) => {
        const orderedWinData = windata.sort(
            (a, b) => a.creditsWon - b.creditsWon
        );
        const winningSymbols = SpinModel.getWinningSymbols();
        const wildPositions = this.searchWilds();
        const megaGroups = [];
        let lastBanner = false;
        let hasMegaCluster = false;
        for (let i = 0; i < orderedWinData.length; i++) {
            this.calculateTotalMulti(wildPositions, orderedWinData[i], i);
        }
        let nonBlackingSymData = [];
        orderedWinData.forEach((win) => {
            win.winReels.forEach((reel, i) => {
                let cellIndex = win.winSymbols[i];
                if (
                    nonBlackingSymData.find(
                        (d) => d.reelIndex === reel && d.cellIndex === cellIndex
                    )
                ) {
                } else {
                    nonBlackingSymData.push({
                        reelIndex: reel,
                        cellIndex: cellIndex,
                    });
                }
            });
        });
        // BBAnimationHelper.blackingSymbols(this, nonBlackingSymData);

        // debugger
        wildPositions.forEach((wild) => {
            let symbol = this.getSymbolAt(wild.x, wild.y);
            let parentSym = symbol.parent;
            parentSym.removeChild(symbol);
            parentSym.addChild(symbol);
        });
        const masterTl = new TimelineMax({
            paused: true,
            onComplete: () => {
                // debugger
                // TweenMax.delayedCall(0.3, () => {
                //     this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
                // })
                this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
            },
        });
        masterTl.add(
            () => BBAnimationHelper.blackingSymbols(this, nonBlackingSymData),
            0.3
        );
        // App.dispatcher.once(
        //     GameEvents.ALL_REELS_STOPPED,
        //     () => {
        //         BBAnimationHelper.blackingSymbols(this, nonBlackingSymData)
        //     },
        //     this
        // );

        ////
        let clusterMessages = [];
        let otherMessages = [];
        let wildRotate = false;
        wildPositions.forEach((wild) => {
            if (wild.counter > 1) {
                wild.groups.forEach((group, index) => {
                    if (!hasMegaCluster) {
                        megaGroups.push(group);
                        let moveSumTl = this.moveSumToWild(
                            orderedWinData,
                            group,
                            wild,
                            index
                        );
                        clusterMessages.push({ ...moveSumTl });
                        masterTl.add(moveSumTl.tl, index / 2);
                        // // wildAnim has loop thats why its called only once
                        // // The SHRINKING is inside the wildAnim function
                        if (!hasMegaCluster && index == 0 && !wildRotate) {
                            masterTl.add(
                                this.wildAnimNew(wild, 1, orderedWinData),
                                index / 2
                            );
                            wildRotate = false;
                        }
                    }
                });
                // debugger
                hasMegaCluster = true;
            }
        });
        if (hasMegaCluster) {
            for (let k = 0; k < orderedWinData.length; k++) {
                if (k == orderedWinData.length - 1) lastBanner = true;
                // CHECK IF A GROUP DOES NOT PARTICIPATE IN THE MEGA CLUSTER THEN ADD IT AS A SECONDARY WIN
                if (!megaGroups.some((groupId) => groupId == k)) {
                    // debugger
                    //bannerCoordinatesArr - the row with most win balloons
                    let banner: any = this.calculateOverlapping(
                        orderedWinData[k]
                    );
                    let bannerPosition = banner.bannerPosition;

                    if (lastBanner) {
                        this.currentBanners = [];
                    }

                    let { tl, winBanner, multi } =
                        this.winlinesView.setGroupWinBannersValue(
                            orderedWinData[k].creditsWon,
                            bannerPosition.x - banner.offset,
                            bannerPosition.y,
                            orderedWinData[k],
                            lastBanner
                        );
                    otherMessages.push({
                        winText: winBanner,
                        multiText: multi,
                        coordinates: orderedWinData[k].coordinates,
                    });
                    masterTl.add(tl, 0);
                }
            }
            // IF THERE ISNT A MEGACLUSTER
        } else {
            for (let k = 0; k < orderedWinData.length; k++) {
                if (k == orderedWinData.length - 1) lastBanner = true;
                let banner: any = this.calculateOverlapping(orderedWinData[k]);
                let bannerPosition = banner.bannerPosition;

                if (lastBanner) {
                    this.currentBanners = [];
                }

                let { tl, winBanner, multi } =
                    this.winlinesView.setGroupWinBannersValue(
                        orderedWinData[k].creditsWon,
                        bannerPosition.x - banner.offset,
                        bannerPosition.y,
                        orderedWinData[k],
                        lastBanner
                    );

                otherMessages.push({
                    winText: winBanner,
                    multiText: multi,
                    coordinates: orderedWinData[k].coordinates,
                });
                masterTl.add(tl, 0);
            }
        }

        let reelBounds = this.getReelsBounds();
        this.winlinesView.setResponsiveScaling();

        // console.log("jovan", SpinModel);

        // App.instance.stage.children
        //     .filter((x) => x.name && x.name.startsWith("debugDrawBounds"))
        //     .forEach((c) => {
        //         App.instance.stage.removeChild(c);
        //     });

        this.getSymbolBounds(clusterMessages);
        this.setTextInFrame(
            [...clusterMessages, ...otherMessages],
            reelBounds
        );
        this.moveMessages(otherMessages, clusterMessages, reelBounds);
        this.moveMultipliers([...clusterMessages, ...otherMessages]);

        masterTl.play();

        this.highlightingAndBlackingWinSymbols(winningSymbols, masterTl).then(
            () => {
                // console.log("--------------------------------------");
                // debugger
                // this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
                // if (!hasMegaCluster) {
                // this.scaleOffWilds(winningSymbols)
                // }
            }
        );
    };

    /**
     * move texts inside the reel bounds
     * @param objects
     */
    private setTextInFrame(
        objects: Array<{ winText; multiText; coordinates }>,
        reelBounds
    ): void {
        for (let i = 0; i < objects.length; i++) {
            BoundUtils.ensureInBounds(
                objects[i].winText,
                reelBounds,
                this.winlinesView.bannerBoundScalar
            );
        }
    }

    /**
     * Setting the new positions and size on the global symbolBound variable
     * @param clusterMessages 
     */
    private getSymbolBounds(clusterMessages) {
        let { onlyTextsArray, symbolBounds } = this.getOnlyTextsArray(
            clusterMessages,
            true
        );

        BoundUtils.scaleBounds(
            symbolBounds,
            this.winlinesView.symbolScalar,
            this.winlinesView.symbolScalarY
        );

        let symbolDisplace = this.getSymbolBoundsSize(
            onlyTextsArray,
            symbolBounds
        );
        this.symbolBounds.width = symbolDisplace.width;
        this.symbolBounds.height = symbolDisplace.height;
        this.symbolBounds.x = symbolBounds.x + symbolDisplace.displaceX;
        this.symbolBounds.y = symbolBounds.y + symbolDisplace.displaceY;
    }

    /**
     * Returns new position and new size of the symbol bounds
     * @param messagesArray 
     * @param symbol 
     * @returns 
     */
    private getSymbolBoundsSize(
        messagesArray: Array<DisplayObject>,
        symbol: Rectangle
    ) {
        let biggestRect = this.getBiggestTextRect(messagesArray);
        let prevSymbolPos = {
            x: symbol.x + symbol.width / 2,
            y: symbol.y + symbol.height / 2,
        };
        symbol.width = biggestRect.width;
        symbol.height = biggestRect.height;

        let newSymbolPos = {
            x: symbol.x + symbol.width / 2,
            y: symbol.y + symbol.height / 2,
        };

        return {
            width: biggestRect.width,
            height: biggestRect.height,
            displaceX: prevSymbolPos.x - newSymbolPos.x,
            displaceY: prevSymbolPos.y - newSymbolPos.y,
        };
    }

    /**
     * Returns biggest bound of cluster messages
     * @param textArray 
     * @returns 
     */
    private getBiggestTextRect(textArray: Array<DisplayObject>) {
        let biggestRect = Rectangle.EMPTY;
        let msgBounds;
        for (let msg of textArray) {
            msgBounds = msg.getBounds();
            BoundUtils.scaleBounds(
                msgBounds,
                this.winlinesView.bannerBoundScalar.upScaleMultiplier,
                this.winlinesView.bannerBoundScalar.upScaleMultiplierY
            );
            if (msgBounds.width > biggestRect.width) {
                biggestRect = msgBounds;
            }
        }
        return biggestRect;
    }

    /**
     * Takes an array of Display Objects or Recangles and draw all rectangles based on their bounds for easier debuging
     * @param array 
     * @param colorName 
     * @param scaleX 
     * @param scaleY 
     * @param getBounds 
     * @param displace 
     */
    private drawMessagesRects(
        array: Array<any>,
        colorName: string,
        scaleX: number,
        scaleY: number,
        getBounds: boolean = true,
        displace: boolean = true
    ) {
        let color =
            colorName == "blue"
                ? 0x374fd4
                : colorName == "red"
                ? 0xf01111
                : colorName == "yellow"
                ? 0xebd534
                : 0x58e82c;
        for (let msg of array) {
            let bounds;
            if (getBounds) {
                bounds = msg.getBounds();
                BoundUtils.scaleBounds(bounds, scaleX, scaleY);
            } else {
                bounds = msg;
            }

            if (displace) {
                if (!GameModel.isMobile() || (GameModel.isMobile() && !Layout.isLandscape())) {
                    bounds.x += msg.children[1].x;
                } 
                bounds.y += msg.height / 2;
            }

            this.drawDebugRect(bounds, color);
        }
    }

    /**
     * we check all messages cluster and non-cluster messages, we check if they overlapps with the symbol,
     * then we check if they overlapps with themselves
     * @param otherMessages 
     * @param clusterMessages 
     * @param reelBounds 
     */
    private moveMessages(
        otherMessages: Array<{ winText; multiText; coordinates }>,
        clusterMessages: Array<{ winText; multiText; coordinates }>,
        reelBounds: Rectangle
    ) {
        let { onlyTextsArray } = this.getOnlyTextsArray(otherMessages, false);
        if (clusterMessages.length > 0) {
            let clusterRect = this.getClusterRect(
                clusterMessages,
                this.symbolBounds
            );
            BoundUtils.ensureRectInReelBounds(clusterRect, reelBounds);
            BoundUtils.ensureRectInReelBounds(this.symbolBounds, clusterRect);
            this.setTextInFrame(clusterMessages, clusterRect)

            let clusterTexts = this.getOnlyTextsArray(clusterMessages, true);

            let clusterTextRectsArray = [];
            for (let clMsg of clusterTexts.onlyTextsArray) {
                clMsg.clusterMsg = true;
                clusterTextRectsArray.push(clMsg);
            }

            this.moveMessageOutsideFrame(
                [...onlyTextsArray, ...clusterTexts.onlyTextsArray],
                this.winlinesView.bannerBoundScalar,
                this.symbolBounds,
                0,
                reelBounds
            );

            this.resolveOverlappingBetweenMessages(
                [...onlyTextsArray, ...clusterTextRectsArray],
                this.winlinesView.bannerBoundScalar,
                0,
                reelBounds,
                this.symbolBounds
            );

        } else {
            if (onlyTextsArray.length > 1) {
                this.resolveOverlappingBetweenMessages(
                    onlyTextsArray,
                    this.winlinesView.bannerBoundScalar,
                    0,
                    reelBounds
                );
            }
        }
    }

    /**
     * Getting the 'bgr_reels' sprite, which fits almost perfectly with the reel bounds
     */
    private getReelsBounds(): Rectangle {
        let reelsBack = ViewManager.getLayer(
            DefaultLayers.ReelsBack
        ).getCurrentScene();
        let reelBounds = (
            reelsBack.children[0] as Container
        ).children[1].getBounds();
        BoundUtils.scaleBounds(reelBounds, this.reelBoundScalar);
        return reelBounds;
    }

    public drawDebugRect(bounds, color = 0xbbbbbb, name = "debugDrawBounds") {
        let rect = new Graphics();
        rect.beginFill(color, 0.5);
        rect.lineStyle(2, 0xbbbbbb);
        rect.drawRect(bounds.x, bounds.y, bounds.width, bounds.height);
        App.instance.stage.addChild(rect);
        rect.name = name;
    }

    /**
     * gets any type of messages cluster or other and returns array with text Objects and symbolBouns if its a cluster
     * @param messagesArray
     * @param cluster
     * @returns
     */
    private getOnlyTextsArray(
        messagesArray: Array<{ winText; multiText; coordinates }>,
        cluster: boolean
    ) {
        let onlyTextsArray = [];
        let symbol: BBReelSymbol;
        let symbolBounds: Rectangle = Rectangle.EMPTY;

        for (let { winText, coordinates } of messagesArray) {
            if (cluster && !symbol && winText.symbol) {
                symbol = winText.symbol;
                symbolBounds = symbol.getBounds();
            }
            winText.coordinates = coordinates;
            // if (getCoordinates) {
            //     onlyTextsArray.push({winText, coordinates});
            // } else {
            // }
            onlyTextsArray.push(winText);
        }
        return { onlyTextsArray, symbolBounds };
    }

    /**
     * move multipliers to the correct position depending on the type of the resolution and device
     * @param allMessages
     */
    private moveMultipliers(
        allMessages: Array<{ winText; multiText; coordinates }>
    ) {
        let multiPosY = 0;
        for (let i = 0; i < allMessages.length; i++) {
            if (GameModel.isMobile() && Layout.isLandscape()) {
                multiPosY = allMessages[i].winText.height / 3;
                allMessages[i].multiText.position.set(
                    allMessages[i].winText.position.x,
                    allMessages[i].winText.position.y + multiPosY
                );
            } else if (GameModel.isMobile() && !Layout.isLandscape()) {
                multiPosY = allMessages[i].winText.height / 3;
                allMessages[i].multiText.position.set(
                    allMessages[i].winText.position.x,
                    allMessages[i].winText.position.y + multiPosY
                );
            } else if (!GameModel.isMobile()) {
                allMessages[i].multiText.position.set(
                    allMessages[i].winText.position.x,
                    allMessages[i].winText.position.y
                );
            }
        }
    }

    /**
     * move cluster messages outside of the bounds of the symbol
     * @param objects
     * @param scalar
     * @param symbolBounds
     * @param iterations
     * @returns
     */
    private moveMessageOutsideFrame(
        objects: Array<DisplayObject>,
        scalar: { upScaleMultiplier; upScaleMultiplierY },
        symbolBounds: Rectangle,
        iterations: number,
        reelBounds: Rectangle,
        restrictedZones: Rectangle = null
    ): void {
        iterations++;
        if (iterations > 1000) {
            return;
        }

        let movedObjects: any = [];
        let hasMoved = false;

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];

            const move = BoundUtils.ensureOutOfBounds(
                object,
                symbolBounds,
                scalar,
                1.0,
                reelBounds,
                restrictedZones,
                false
            );
            if (move.x != null && (move.x != object.x || move.y != object.y)) {
                movedObjects.push({ object, newPosition: move });
                hasMoved = true;
            }
        }

        if (hasMoved) {
            this.moveObjects(movedObjects);
            this.moveMessageOutsideFrame(
                objects,
                scalar,
                symbolBounds,
                iterations,
                reelBounds,
                restrictedZones
            );
        }
    }

    /**
     * moves other messages if they overlapps with each other
     * @param objects
     * @param scalar
     * @param iterations
     * @returns
     */
    private resolveOverlappingBetweenMessages(
        objects,
        scalar: { upScaleMultiplier; upScaleMultiplierY },
        iterations: number,
        reelBounds: Rectangle,
        restrictedZone: Rectangle = null
    ) {
        iterations++;
        if (iterations > 1000) {
            return;
        }

        let movedObjects: Array<any> = [];
        let hasMoved = false;

        for (let i = 0; i < objects.length; i++) {
            const object = objects[i];
            for (let j = 0; j < objects.length; j++) {
                const nextObject = objects[j];

                if (i != j && (!object.clusterMsg || !nextObject.clusterMsg)) {
                    const move = BoundUtils.ensureOutOfBounds(
                        object,
                        nextObject.getBounds(),
                        scalar,
                        scalar,
                        reelBounds,
                        restrictedZone,
                        true
                    );

                    if (
                        move.x != null &&
                        (move.x != object.x || move.y != object.y)
                    ) {
                        movedObjects.push({ object, newPosition: move });
                        hasMoved = true;
                    }
                }
            }
        }

        if (hasMoved) {
            this.moveObjects(movedObjects);
            this.resolveOverlappingBetweenMessages(
                objects,
                scalar,
                iterations,
                reelBounds,
                restrictedZone
            );
        }
    }

    /**
     * moves given objects in their new positions
     * @param movedObjects
     */
    private moveObjects(movedObjects: Array<any>) {
        for (let { object, newPosition } of movedObjects) {
            object.position.set(newPosition.x, newPosition.y);
        }
    }

    /**
     * makes one big rectangle from all cluster texts rectangles and symbolBounds
     * @param clusterMessages
     * @param symbolBounds
     * @returns
     */
    private getClusterRect(
        clusterMessages: Array<{ winText; multiText; coordinates }>,
        symbolBounds: Rectangle
    ) {
        let bounds: Rectangle = undefined;
        for (let { coordinates } of clusterMessages) {
            coordinates.forEach((c) => {
                let symBounds = this.getSymbolAt(
                    c.x - 1,
                    c.y - 1
                ).children[0].getBounds();
                if (!bounds) {
                    bounds = symBounds;
                } else {
                    bounds.enlarge(symBounds);
                }
            });
        }
        bounds.enlarge(symbolBounds);
        return bounds;
    }

    public scaleOffWilds = () => {
        // let wilds = this.searchWilds();
        // wilds.forEach(wild => {
        //     let sym = this.getSymbolAt(wild.x, wild.y);
        //     sym.playSpineAnim("scale_down", false)
        // })

        const winningSymbols = SpinModel.getWinningSymbols();
        winningSymbols.forEach((reel, i) => {
            reel.forEach((row, j) => {
                let sym = this.getSymbolAt(i, j);
                if (row) {
                    if (sym.id === 0) {
                        sym.playSpineAnim("scale_down", false);
                    }
                } else {
                    // sym.showActiveAnim();
                    // sym.blackening().reverse();
                }
            });
        });
    };

    private highlightingAndBlackingWinSymbols = (
        winningSymbols: boolean[][],
        masterTl: TimelineMax
    ): Promise<SymbolSpineAnimation> => {
        let promiseList: Promise<SymbolSpineAnimation>[] = [];
        winningSymbols.forEach((reel, i) => {
            reel.forEach((row, j) => {
                let sym = this.getSymbolAt(i, j);
                if (row) {
                    promiseList.push(
                        new Promise((res) => {
                            let state =
                                sym.id === 0 ? "scale_on_idle" : "scale_intro";
                            sym.playAsyncSpineAnim(state).then(() => {
                                res();
                            });
                        })
                    );
                } else {
                    // sym.hideActiveAnim();
                    // masterTl.add(sym.blackening(), 0)
                }
            });
        });

        return PromiseHelpers.combineParallel(promiseList);
    };

    public wildAnimNew(wildPosition: any, numberOfLoops: any, windata: any) {
        let wildSymbol = this.getSymbolAt(wildPosition.x, wildPosition.y);

        let tl = new TimelineMax({
            paused: false,
        });

        let parentSym = wildSymbol.parent;
        parentSym.removeChild(wildSymbol);
        parentSym.addChild(wildSymbol);

        for (let i = 0; i < numberOfLoops; i++) {
            tl.add(
                () => {
                    wildSymbol.playSpineAnim("rotate", false, 2.5);
                    SoundController.playSound("wild_turn");
                },
                i == 0 ? 1 : i + 0.7
            );
            if (i == numberOfLoops - 1) {
                let delay = "+=" + (numberOfLoops * 0.2).toString();
                tl.add(
                    () =>
                        wildSymbol.playSpineAnim("back_from_rotate", false, 1),
                    delay
                );
                tl.add(TweenMax.to({}, 1, {}), delay);
            }
        }
        return tl;
    }
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////

    public showWaysSummary(windata: IWinData[]) {
        // debugger
        let wildPositions = this.searchWilds();
        let lastBanner = false;
        let hasMegaCluster = false;
        let expandedSymbols = false;
        let totalWild = -1;
        let megaGroups = [];
        for (let i = 0; i < windata.length; i++) {
            this.calculateTotalMulti(wildPositions, windata[i], i);
        }
        let timelineCounter = 0;
        const masterTl = new TimelineMax({
            paused: true,
            onComplete: () => {
                // this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
            },
        });
        const tl = new TimelineMax({
            paused: true,
            onComplete: () => {
                if (megaGroups.length > 0) {
                    TweenMax.delayedCall(megaGroups.length + 1, () => {
                        tlReverse();
                    });
                } else {
                    tlReverse();
                }
            },
        });
        function tlReverse() {
            tl.reverse();
        }
        wildPositions.forEach((wild) => {
            if (wild.counter > 1) {
                this.showWinStateDelayedExit = 0;
                wild.groups.forEach((group, index) => {
                    if (!hasMegaCluster) {
                        megaGroups.push(group);
                        let moveSumTl = this.moveSumToWild(
                            windata,
                            group,
                            wild,
                            index
                        );
                        if (!expandedSymbols) {
                            masterTl.add(
                                this.expandMegaSymbols(
                                    group,
                                    windata,
                                    wild,
                                    moveSumTl.tl.totalDuration(),
                                    wild.counter
                                ),
                                timelineCounter
                            );
                            if (index == wild.groups.length - 1) {
                                expandedSymbols = true;
                            }
                        }
                        masterTl.add(moveSumTl, timelineCounter);
                        // wildAnim has loop thats why its called only once
                        // The SHRINKING is inside the wildAnim function
                        if (!hasMegaCluster && index == 0) {
                            masterTl.add(
                                this.wildAnim(
                                    wild,
                                    wild.groups.length,
                                    windata
                                ),
                                timelineCounter
                            );
                        }
                    }
                });
                hasMegaCluster = true;
            } else {
                this.showWinStateDelayedExit = 0.8;
            }
        });
        // TODO use the windata insteand of winningSymbols
        const winningSymbols = SpinModel.getWinningSymbols();
        this.symAnimationCount = 0;
        // HIGHLIGHTING THE WINNING SYMBOLS AND BLACKENING THE OTHERS
        for (let i = 0; i < winningSymbols.length; i++) {
            for (let j = 0; j < winningSymbols[i].length; j++) {
                if (winningSymbols[i][j]) {
                    const symbol = this.getSymbolAt(i, j);
                    symbol.showWin();
                    this.symAnimationCount++;

                    let symbolAnim = this.winSymbolsView.getAnimAtReelCell(
                        i,
                        j
                    );
                    symbolAnim.visible = true;
                    // symbolAnim.setId(symbol.id)

                    this.winSymbolsView
                        .playAnimaAtReelCell(i, j, symbol.getId(), "anim")
                        .then(() => {
                            this.symAnimationCount--;
                        });

                    if (symbol.id != 0 && !hasMegaCluster) {
                        // symbolAnim.setId(symbol.id)
                        // reduce exploding ballon anim
                        masterTl.add(
                            TweenMax.to(symbolAnim.scale, 0.4, {
                                x: 1.25,
                                y: 1.25,
                                onComplete: () => {
                                    symbolAnim.scale.x = 1;
                                    symbolAnim.scale.y = 1;
                                },
                            }),
                            timelineCounter * 1.5
                        );
                    }
                } else {
                    const symbol = this.getSymbolAt(i, j);
                    tl.add(symbol.blackening(), 0);
                }
            }
        }

        // SORTING THE WINNING SYMBOLS - Y for centering the banner in the group
        //IF THERE IS A MEGA CLUSTER
        if (hasMegaCluster) {
            for (let k = 0; k < windata.length; k++) {
                if (k == windata.length - 1) lastBanner = true;
                // CHECK IF A GROUP DOES NOT PARTICIPATE IN THE MEGA CLUSTER THEN ADD IT AS A SECONDARY WIN
                if (!megaGroups.some((groupId) => groupId == k)) {
                    //bannerCoordinatesArr - the row with most win balloons
                    let banner: any = this.calculateOverlapping(windata[k]);
                    let bannerPosition = banner.bannerPosition;

                    if (lastBanner) {
                        this.currentBanners = [];
                    }

                    let { tl } = this.winlinesView.setGroupWinBannersValue(
                        windata[k].creditsWon,
                        bannerPosition.x - banner.offset,
                        bannerPosition.y,
                        windata[k],
                        lastBanner
                    );
                    masterTl.add(tl, megaGroups.length);
                }
            }
            // IF THERE ISNT A MEGACLUSTER
        } else {
            for (let k = 0; k < windata.length; k++) {
                if (k == windata.length - 1) lastBanner = true;
                let banner: any = this.calculateOverlapping(windata[k]);
                let bannerPosition = banner.bannerPosition;

                if (lastBanner) {
                    this.currentBanners = [];
                }

                let { tl } = this.winlinesView.setGroupWinBannersValue(
                    windata[k].creditsWon,
                    bannerPosition.x - banner.offset,
                    bannerPosition.y,
                    windata[k],
                    lastBanner
                );
                masterTl.add(tl, timelineCounter);
            }
            masterTl.add(() => {
                this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
            }, "-=1.5");
        }
        masterTl.play();
        tl.play();
        // MAKE THE WILDS GO ON TOP OF THE WINNING SYMBOLS (OVERLAPPING)
        wildPositions.forEach((wild) => {
            let symbol = this.winSymbolsView.getAnimAtReelCell(wild.x, wild.y);
            let parentSym = symbol.parent;
            parentSym.removeChild(symbol);
            parentSym.addChild(symbol);
        });
    }

    private expandMegaSymbols(group, windata, wild, moveSumDuration, wildsNum) {
        let tl = new TimelineMax({ paused: false });
        let delay = "+=" + (wild.groups.length + 1.5).toString();
        windata[group].coordinates.forEach((coordinate) => {
            if (!(wild.x == coordinate.x - 1 && wild.y == coordinate.y - 1)) {
                let symId = this.getSymbolAt(
                    coordinate.x - 1,
                    coordinate.y - 1
                ).id;
                let symbol = this.winSymbolsView.getAnimAtReelCell(
                    coordinate.x - 1,
                    coordinate.y - 1
                );
                symbol.setId(symId);
                tl.add(
                    TweenMax.to(symbol.scale, 1, {
                        x: 1.25,
                        y: 1.25,
                        onComplete:
                            symbol.id != 0
                                ? () => {
                                      TweenMax.delayedCall(
                                          moveSumDuration
                                              ? moveSumDuration + wildsNum
                                              : 0,
                                          () => {
                                              symbol.scale.x = 1;
                                              symbol.scale.y = 1;
                                          }
                                      );
                                  }
                                : () => {},
                    }),
                    0
                );

                if (symbol.id == 0) {
                    tl.add(
                        TweenMax.to(symbol.scale, 0, {
                            x: 1,
                            y: 1,
                        }),
                        delay
                    );
                }
            }
        });
        return tl;
    }

    private moveSumToWild(windata, group, wild, tweenIndex) {
        let lastBanner = tweenIndex == wild.groups.length - 1;
        let delay = "";
        if (tweenIndex == 0) {
            delay = "0";
        } else {
            delay = "+=" + 0.8 * tweenIndex;
        }
        let tl = new TimelineMax({ paused: false });
        let banner: any = this.calculateOverlapping(windata[group]);
        let bannerPosition = banner.bannerPosition;

        if (lastBanner) {
            this.currentBanners = [];
        }

        let winBannersValue = this.winlinesView.setGroupWinBannersValue(
            windata[group].creditsWon,
            bannerPosition.x - banner.offset,
            bannerPosition.y,
            windata[group],
            lastBanner,
            wild
        );

        (<any>winBannersValue.winBanner).symbol = this.getSymbolAt(
            wild.x == 0 ? 1 : wild.x == 7 ? 6 : wild.x,
            wild.y
        );

        tl.add(winBannersValue.tl, delay);
        return {
            tl,
            winText: winBannersValue.winBanner,
            multiText: winBannersValue.multi,
            coordinates: windata[group].coordinates,
        };
    }

    private shrinkMegaSymbols(windata, wild) {
        let tl = new TimelineMax({ paused: false });
        wild.groups.forEach((group) => {
            windata[group].coordinates.forEach((coordinate) => {
                if (
                    this.winSymbolsView.hasAnimAtReelCell(
                        coordinate.x - 1,
                        coordinate.y - 1
                    )
                ) {
                    if (
                        !(
                            wild.x == coordinate.x - 1 &&
                            wild.y == coordinate.y - 1
                        )
                    ) {
                        let symbol = this.winSymbolsView.getAnimAtReelCell(
                            coordinate.x - 1,
                            coordinate.y - 1
                        );
                        // if (symbol.id == 0) {
                        //     tl.add(TweenMax.to(symbol.scale, 0.5, {
                        //         x: 1,
                        //         y: 1
                        //     }), 0)
                        // }

                        tl.add(() => {
                            this.emit(GameEvents.WIN_ANIMATIONS_COMPLETE);
                        }, 0.5);
                        if (symbol.id != 0) {
                            tl.add(
                                TweenMax.to(symbol.scale, 1, {
                                    x: 1,
                                    y: 1,
                                }),
                                1
                            );
                        }
                    }
                }
            });
        });
        return tl;
    }

    private calculateTotalMulti(wildPositions, winData, groupIndex) {
        wildPositions.forEach((wild) => {
            winData.coordinates.forEach((coords) => {
                if (wild.x == coords.x - 1 && wild.y == coords.y - 1) {
                    wild.counter += 1;
                    wild.groups.push(groupIndex);
                    // debugger
                    // console.log("push groupIndex", groupIndex)
                }
            });
        });
    }

    public searchWilds(): {
        x: number;
        y: number;
        counter: number;
        groups: [];
    }[] {
        let res = [];
        this.reels.forEach((reel, i) => {
            reel.symbols.forEach((symbol, j) => {
                if (symbol.id == 0) {
                    res.push({ x: i, y: j, counter: 0, groups: [] });
                }
            });
        });

        return res;
    }

    public getSymbolAt(reelId: number, rowId: number): BBReelSymbol {
        return this.reels[reelId].symbols[
            rowId + this.groupConfig.reelExtraSymbols
        ] as BBReelSymbol;
    }

    public calculateBannerPosition(windata) {
        let countMap = {};
        let maxOccurrenceEl = windata.coordinates[0].y;
        let maxCount = 1;
        for (let i = 0; i < windata.coordinates.length; i++) {
            let el = windata.coordinates[i].y;
            if (countMap[el] == null) countMap[el] = 1;
            else countMap[el]++;
            if (countMap[el] > maxCount) {
                maxOccurrenceEl = el;
                maxCount = countMap[el];
            }
        }
        let coordinatesMaxEl = [];
        windata.coordinates.forEach((coordinate) => {
            if (coordinate.y == maxOccurrenceEl) {
                coordinatesMaxEl.push({ x: coordinate.x, y: coordinate.y });
            }
        });
        coordinatesMaxEl.sort(function (a, b) {
            return a.x - b.x;
        });

        return coordinatesMaxEl;
    }

    public popSymbols(winningSymbols?: boolean[][]) {
        let expSymPromises: Promise<SymbolSpineAnimation>[] = [];
        let symbols: BBReelSymbol[] = [];
        winningSymbols.forEach((reel, i) => {
            reel.forEach((row, j) => {
                if (row) {
                    expSymPromises.push(
                        new Promise((res) => {
                            let symbol = this.getSymbolAt(i, j);
                            symbols.push(symbol);
                            symbol.playAsyncSpineAnim("outro").then(() => {
                                res();
                            });
                        })
                    );
                }
            });
        });

        if (expSymPromises.length > 0) {
            PromiseHelpers.combineParallel(expSymPromises).then(() => {
                symbols.forEach((sym) => sym.spineAnim.hide());
                this.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED);
                BBAnimationsHelper.unBlackingSymbols(this);
            });
        } else {
            this.dispatcher.emit(GameEvents.ALL_SYMBOLS_POPPED);
        }
    }

    private calculateOverlapping(windata): any {
        let bannerCoordinatesArr = this.calculateBannerPosition(windata);
        //Choosing the middle balloon for the banner
        let bannerResultCoordinates =
            bannerCoordinatesArr[
                Math.ceil(bannerCoordinatesArr.length / 2 - 1)
            ];
        if (bannerResultCoordinates.y == 8) {
            bannerResultCoordinates.y = 7;
        }
        if (bannerResultCoordinates.x == 8) {
            bannerResultCoordinates.x = 7;
        }
        if (
            bannerResultCoordinates.x == 1 &&
            bannerCoordinatesArr.length == 1
        ) {
            bannerResultCoordinates.x = 2;
        }
        this.currentBanners.forEach((banner) => {
            //IF THE CLUSTERS ARE VERTICAL AND NEXT TO EACH OTHER
            if (
                (bannerCoordinatesArr[0].y == banner.y &&
                    bannerCoordinatesArr[0].x - 1 == banner.x) ||
                (bannerCoordinatesArr[0].y == banner.y &&
                    bannerCoordinatesArr[0].x + 1 == banner.x)
            ) {
                let found = windata.coordinates.find(
                    (coordinates) =>
                        coordinates.y != bannerCoordinatesArr[0].y &&
                        coordinates.y != 8
                );
                if (found != undefined) {
                    bannerResultCoordinates = found;
                }
            }
            //IF THE CLUSTERS ARE HORIZONTAL AND NEXT TO EACH OTHER
            if (
                (bannerCoordinatesArr[0].y - 1 == banner.y ||
                    bannerCoordinatesArr[0].y + 1 == banner.y) &&
                bannerCoordinatesArr[
                    Math.ceil(bannerCoordinatesArr.length / 2 - 1)
                ].x == banner.x
            ) {
                let found = windata.coordinates.find(
                    (coordinates) =>
                        coordinates.x !=
                            bannerCoordinatesArr[
                                Math.ceil(bannerCoordinatesArr.length / 2 - 1)
                            ].x &&
                        coordinates.x !=
                            bannerCoordinatesArr[
                                Math.ceil(bannerCoordinatesArr.length / 2 - 1)
                            ].x -
                                1 &&
                        coordinates.x != 8
                );
                if (found != undefined) {
                    bannerResultCoordinates = found;
                }
            }
        });
        let bannerPosition = this.getSymbolAt(
            bannerResultCoordinates.x - 1,
            bannerResultCoordinates.y - 1
        );
        //Setting an offset because the banner isn't centered if the number of balloons on the row is odd
        let offset = bannerCoordinatesArr.length % 2 == 0 ? 0 : 50;

        // No hardcoded offset anymore
        offset = 0;

        this.currentBanners.push({
            x: bannerResultCoordinates.x,
            y: bannerResultCoordinates.y,
        });

        return { bannerPosition: bannerPosition, offset: offset };
    }

    // public mainThunderBolt(DESymbol) {
    //     let centerBolt = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "5" + "_",
    //         3,
    //         24
    //     );
    //     this.thunderBoltSprite({ x: 0.5, y: 1 }, centerBolt, DESymbol)
    // }

    // public thunderBolts(DESymbol) {
    //     let framesBottomLeft = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "1" + "_",
    //         3,
    //         24
    //     );
    //     let framesBottomRight = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "2" + "_",
    //         3,
    //         24
    //     );
    //     let framesTopRight = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "3" + "_",
    //         3,
    //         24
    //     );
    //     let framesTopLeft = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "4" + "_",
    //         3,
    //         24
    //     );
    //     let center = this.assets.generateFrames(
    //         "thunderbolt" + "_" + "4" + "_",
    //         3,
    //         24
    //     );
    //     this.thunderBoltSprite({ x: 0.9, y: 0.15 }, framesBottomLeft, DESymbol, 0.1)
    //     this.thunderBoltSprite({ x: 0.1, y: 0.9 }, framesTopRight, DESymbol, 0.15)
    //     this.thunderBoltSprite({ x: 0.9, y: 0.9 }, framesTopLeft, DESymbol, -0.15)
    //     this.thunderBoltSprite({ x: 0.1, y: 0.15 }, framesBottomRight, DESymbol, 0.1)
    // }

    public DESymbolAnimation(DESymbol: BBReelSymbol) {
        if (DESymbol.id !== 0) {
            SoundController.playSound("destroy_suspense", false);
            SoundController.playSound("destroy_select", false);
            DESymbol.playSpineAnim("thunder");
        }
    }
    public DESymbolAnimationPop(DESymbol: BBReelSymbol) {
        if (DESymbol.id !== 0) {
            SoundController.playSound("destroy_pop");
            DESymbol.playSpineAnim("shot_lightning", false);
        }
    }
    public idleSymbolAnimation(DESymbol: BBReelSymbol) {
        if (DESymbol.id !== 0) {
            DESymbol.playSpineAnim();
        }
    }

    // public thunderBoltSprite(anchor, frames, symbol, rotation?) {

    //     const sprite = new PIXI.extras.AnimatedSprite(frames);
    //     sprite.animationSpeed = this.thunderBoltAnimSpeed
    //     sprite.anchor.set(anchor.x, anchor.y);
    //     sprite.loop = false;
    //     sprite.position.x = symbol.position.x;
    //     sprite.position.y = symbol.position.y;
    //     if (rotation) {
    //         sprite.rotation = rotation;
    //     }
    //     sprite.width = symbol.width * 20;
    //     sprite.height = symbol.height * 20;
    //     this.symContainer.addChild(sprite);
    //     sprite.gotoAndPlay(0);
    // }

    public wildEffect(sym, target) {
        // let layer = ViewManager.getLayer(DefaultLayers.Paylines).getCurrentScene()
        // let effect = layer.anims
        // let anim;
        // let tl = new TimelineMax({ paused: false, onComplete: () => {
        //     sym.visible = true;
        // } })
        // for (let i = 1; i < 6; i++) {
        //     if (effect.has("sym_wild_glow" + i)) {
        //         if (effect.get("sym_wild_glow" + i)["used"] == false) {
        //             anim = effect.get("sym_wild_glow" + i)
        //             break;
        //         }
        //     }
        // }
        // anim.visible = true
        // anim["used"] = true;
        // anim.animationSpeed = 0.6
        // anim.loop = false;
        // anim.anchor.set(0.5, 0.5)
        // anim.position.x = sym.x;
        // anim.position.y = target;
        // layer.addSubView(anim, "wildEffect", "lines")
        // tl.add(() => { anim.gotoAndPlay(0) }, 0)
        // TweenMax.delayedCall(1, () => {
        //     anim["used"] = false;
        //     anim.visible = false;
        // })
    }

    public stormCloudsAnimation(timing, frames, killSpriteDelay, loop?) {
        let anim = this.assets.generateFrames(
            "STORM_CLOUDS" + "_" + timing + "_",
            3,
            frames
        );
        let layer = ViewManager.getLayer("Header").getCurrentScene();
        const sprite = new PIXI.extras.AnimatedSprite(anim);
        sprite.animationSpeed = 0.5;
        if (loop) {
            sprite.loop = true;
        } else {
            sprite.loop = false;
        }
        sprite.position.x = 0;
        sprite.position.y = 0;

        layer.addChild(sprite);
        sprite.gotoAndPlay(0);
        TweenMax.delayedCall(killSpriteDelay, () => {
            layer.removeChild(sprite);
            sprite.destroy();
        });
    }
}

export default BBReelGroup;
